import { hasPremium } from '@/helpers/feature/feature';

import * as actions from './common-actions';
import * as mutations from './common-mutations';
import { CommonState, state } from './common-state';

const getters = {
  getterCommonAreLikesAvailable(state: CommonState): boolean {
    return state.index.likesLimitRemainCount > 0 || hasPremium();
  },
};

export const common = {
  state,
  mutations,
  actions,
  getters,
};
